import { Text } from "@assetwatch/ui";

export function ProcedureSectionDisclosure({
  label,
  expanded,
  onToggle,
  variant = "section",
}: {
  label: string;
  expanded: boolean;
  onToggle: () => void;
  variant?: "root" | "section";
}) {
  return (
    <button
      aria-expanded={expanded}
      className={
        variant === "root"
          ? "flex items-center gap-(--spacing-8) border-b border-outline-subtle pb-(--spacing-8) text-left"
          : "mb-(--spacing-8) flex items-center gap-(--spacing-6) text-left"
      }
      onClick={onToggle}
      type="button"
    >
      <span aria-hidden="true">{expanded ? "⌄" : "›"}</span>
      {variant === "root" ? (
        <Text weight="medium">{label}</Text>
      ) : (
        <Text size="sm" weight="medium">
          {label}
        </Text>
      )}
    </button>
  );
}
